import { render, staticRenderFns } from "./road-details.vue?vue&type=template&id=380988e7&"
import script from "./road-details.vue?vue&type=script&lang=js&"
export * from "./road-details.vue?vue&type=script&lang=js&"
import style0 from "./road-details.vue?vue&type=style&index=0&id=380988e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports